import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "upload" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.piniaStore.state.dateien.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.piniaStore.state.dateien, (file, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: file.id
          }, _toDisplayString(index > 0 ? ", " : "") + " " + _toDisplayString(file.name), 1))
        }), 128))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, "keine"))
  ]))
}